<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Emitentes" />
  <menuLateral />

  <!-- Content Wrapper -->
  <div class="content-wrapper">

    <!-- Header -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <b-button
              class="botoes"
              variant="outline-primary btn-sm mt-2"
              @click="incluirEmitente()"
              :disabled="flagsDeControle.carregandoDados.status">
              Incluir
            </b-button>
          </div>
        </div>
      </div>
    </section>

    <!-- Content -->
    <section class="content">
      <div class="card">
        <div class="card-body">

          <!-- Loading -->
          <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
            <span class="avisoDanger">
              {{ flagsDeControle.carregandoDados.mensagem }}
            </span>
            <b-spinner class="ml-2" variant="danger" />
          </div>

          <!-- Filtros -->
          <div class="card bg-light d-flex flex-fill">
            <div class="card-header border-bottom-0">

              <form v-on:keyup.enter="buscarRegistros()">
                <div class="form-row">

                  <div class="form-group col-md-4">
                    <b-form-group label="Razão Social" label-size="sm" class="mb-0" />
                    <b-form-input
                      id="razaoSocial"
                      v-model="camposFiltroPesquisa.razaoSocial"
                      type="text"
                      :disabled="flagsDeControle.carregandoDados.status"/>
                  </div>

                  <div class="form-group col-md-4">
                    <b-form-group label="CNPJ" label-size="sm" class="mb-0" />
                    <b-form-input
                      id="cnpj"
                      v-model="camposFiltroPesquisa.cnpj"
                      type="text"
                      :disabled="flagsDeControle.carregandoDados.status"/>
                  </div>

                  <div class="form-group col-md-4">
                    <b-form-group label="Inscrição Municipal" label-size="sm" class="mb-0" />
                    <b-form-input
                      id="inscricaoMunicipal"
                      v-model="camposFiltroPesquisa.inscricaoMunicipal"
                      type="text"
                      :disabled="flagsDeControle.carregandoDados.status"/>
                  </div>

                  <div class="form-group text-right mt-auto ml-auto">
                    <b-button
                      class="botoes"
                      variant="outline-secondary btn-sm"
                      @click="limparFiltros()"
                      :disabled="flagsDeControle.carregandoDados.status">
                      Limpar
                    </b-button>

                    <b-button
                      class="botoes ml-1"
                      variant="outline-primary btn-sm"
                      @click="buscarRegistros()"
                      :disabled="flagsDeControle.carregandoDados.status">
                      Buscar
                    </b-button>
                  </div>

                </div>
              </form>

            </div>
          </div>

          <!-- Tabela -->
          <default-table
            :items="listaEmitentes"
            :fields="fields"
            :sort-by="componenteOrdenacao.campo"
            :sort-direction="componenteOrdenacao.sentido"
            :busy="flagsDeControle.carregandoDados.status"
            @sortChanged="ordenarLista">

            <template v-slot:cell(razao_social)="row">
              <a href="#"
                v-on:click.stop.prevent="editarEmitente(row.item.id)"
                :disabled="flagsDeControle.carregandoDados.status">

                {{ row.item.razao_social }}
              </a>
            </template>

            <template #empty>
              <em>Nenhum registro encontrado.</em>
            </template>

          </default-table>

          <!-- Paginação -->
          <pagination
            :fonteDeDados="componentePaginacao.fonteDeDados"
            :disabled="flagsDeControle.carregandoDados.status"
            @navegarNaPaginacao="obterDadosPaginados"/>

        </div>
      </div>
    </section>

  </div>
</div>
</template>

<script>
import Emitentes from './js'
export default Emitentes
</script>

<style scoped>
@import "./scss/emitentes.scss";
</style>
